import React, { Component } from 'react'
import { Table } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import columns from '../../column'
import store from '../../store'

@observer
export default class extends Component {
  componentDidMount() {
    store.dataLoading('status=0&per_page=10')
    store.dataLoading('status=1&per_page=10')
    store.dataLoading('status=2&per_page=10')
  }
  render() {
    let { list, loading } = store
    return (
      <div>
        <Table
          rowKey={record => record.id}
          loading={loading}
          bordered
          columns={columns}
          pagination={store.pagination_1}
          dataSource={toJS(list)}
          onChange={store.paging('1')}
        />
      </div>
    )
  }
}
